export default class User {
    constructor(token, pinCode, docsetID) {
        this.token = token || "";
        this.pinCode = pinCode || "";
        this.docsetID = docsetID || "";
        this.id = undefined;
    }
    get hasCredentials() {
        return this.docsetID && this.token && this.pinCode;
    }
}